import { AutoCompleteOption } from "../common/AutoComplete";
import EquipmentAssociationService from "./EquipmentAssociationService";

export const getAllAcriss = (tenant:string): Promise<AutoCompleteOption[]> => {
  return EquipmentAssociationService.get.allAcriss(tenant).then(
    response => response.map((res) => ({ label: `${res.code} - ${res.label}`, value: res.id })),
  );
}

export const getAllKits = (tenant:string): Promise<AutoCompleteOption[]> => {
  return EquipmentAssociationService.get.allKits(tenant).then(
    response => response.map((res) => ({ label: `${res.code} - ${res.descr}`, value: res.id })),
  )
}